import logo from './logo.png';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          SITE EN CONSTRUCTION
        </p>
        <a href="mailto:contact@bde42marseille.fr" className="contact-button">
          CONTACT
        </a>
      </header>
    </div>
  );
}

export default App;
